import { TableCell, TableRow } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import CadastroAtividadesModal from '../../pages/Contratos/Fluxos/FluxoCentralizados/ContratoEntePrivadoEdit/CadastroAtividadesModal';
import GenericDados from '../../pages/Contratos/Fluxos/FluxoCentralizados/ContratoEntePrivadoEdit/GenericDados';
import {
  cadastroContratoEntePrivado,
  changeContratoEntePrivadoEditingValue,
} from '../../store/modules/ContratosEntePrivadoActions';
import { openModal } from '../../store/modules/ModalActions';
import { getElementID, getMergedClassNames } from '../../utils/HTMLUtils';
import ConfirmModal from '../ConfirmModal/ConfirmModal';
import DeleteForeverIcon from '../Icons/DeleteForeverIcon';
import EditIcon from '../Icons/EditIcon';
import styles from './AtividadesItem.scss';
import { getCurrencyFormat } from '../../utils/NumberUtils';

const rootClassName = styles.rootClassName;

class AtividadesItem extends GenericDados {
  constructor(props) {
    super(props);
    this.state = {
      atividadesList: this.props.contratosEntePrivado.contratoEditing.atividades
        ? this.props.contratosEntePrivado.contratoEditing.atividades
        : [],
    };
  }

  allowEditButton() {
    return true;
  }

  openEdicaoAtividades = () => {
    this.props.openModal(CadastroAtividadesModal, {
      atividade: this.props.atividade,
      savedCallback: this.props.changeAtividades,
    });
  };

  toRemove = () => {
    this.props.changeAtividades(null, this.props.atividade.index);
  };

  confirmRemoverAtividade = () => {
    this.props.openModal(ConfirmModal, {
      title: this.props.languageValues.confirmDeleteAtividadeModalTitle,
      /* eslint-disable-next-line */
      content: this.props.languageValues.confirmDeleteAtividade,
      confirmLabel: this.props.languageValues.removerProjetoModalConfirmLabel,
      confirmCallback: this.toRemove,
    });
  };

  render() {
    return (
      <TableRow
        cols={[12, 12, 6, 6, 6]}
        id={getElementID(this.props.id, 'row')}
        className={rootClassName + '-plano-trabalho-row'}
        index={this.props.index}
      >
        {this.allowEditButton() ? (
          <TableCell className={rootClassName + '-cell'}>
            <button
              type={'button'}
              onClick={this.openEdicaoAtividades}
              disabled={this.props.fieldDisabled()}
              className={rootClassName + '-table-action-button'}
            >
              <EditIcon className={rootClassName + '-table-action-icon'} />
            </button>
          </TableCell>
        ) : null}
        <TableCell
          onClick={
            !this.props.fieldDisabled() ? this.openEdicaoAtividades : null
          }
          className={getMergedClassNames([
            rootClassName + '-cell ',
            !this.props.fieldDisabled() ? rootClassName + '-link-cell' : '',
          ])}
        >
          {this.props.atividade.atividade}
        </TableCell>
        <TableCell
          onClick={
            !this.props.fieldDisabled() ? this.openEdicaoAtividades : null
          }
          className={getMergedClassNames([
            rootClassName + '-cell ',
            !this.props.fieldDisabled() ? rootClassName + '-link-cell' : '',
          ])}
        >
          {getCurrencyFormat(
            this.props.atividade.custo,
            this.props.languageValues
          )}
        </TableCell>
        <TableCell className={rootClassName + '-cell'}>
          <button
            type={'button'}
            onClick={this.confirmRemoverAtividade}
            className={rootClassName + '-table-action-button'}
            disabled={this.props.fieldDisabled()}
          >
            <DeleteForeverIcon
              className={rootClassName + '-table-action-icon'}
            />
          </button>
        </TableCell>
      </TableRow>
    );
  }
}

AtividadesItem.propTypes = {
  atividade: PropTypes.object.isRequired,
  fieldDisabled: PropTypes.func.isRequired,
  changeAtividades: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratosEntePrivado: state.contratosEntePrivado,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeContratoEntePrivadoEditingValue,
      openModal,
      cadastroContratoEntePrivado,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AtividadesItem));
